// src/components/CarteTitrePage.jsx — LA carte de titre de page.
// V2 (maquette validée Dimitri 2026-08-15) — REMPLACE la v1 ciel pâle :
// le DÉGRADÉ et le LOTUS descendent ici. Ils signent LA PAGE, pas
// l'application — ils accompagnent le contenu au lieu d'être un décor
// permanent (le bandeau du haut est devenu une barre blanche unique).
//
// LA CARTE SERT, elle ne décore pas : sous le titre, LES CHIFFRES DU JOUR
// (« 6 ménages · 2 à régler · 3 agents · 9 h de travail ») — chaque page
// passe les siens via `chiffres`. Une page sans chiffres qui vaillent :
// pas de section, juste le titre et la date.
//
//   · dégradé 115deg #233240 → #3d5166 → #5c8ab8 (borné : jamais le ciel
//     plein, le blanc reste lisible partout)
//   · AUCUN filigrane (Dimitri 2026-08-17 : « le dégradé navy suffit ») —
//     90 px, en bas à droite (bottom -12 / right 40), opacité .16,
//     SOUS le contenu — coupé net par l'overflow : il ÉMERGE par le bas.
//   · titre Fraunces 22 BLANC ; sous-titre 11.5 blanc 75 % (la date)
//   · chiffres : nombre 22 blanc (alerte #f5a892 si > 0), libellé 10.5
//     blanc 75 %, séparés par des filets 1px blanc 16 %
//   · boutons : fond BLANC, texte #3d5166 (actif d'un mode d'argent : corail)

import { DS } from '../lib/ui'
import { ChevronLeft } from 'lucide-react'

const DEGRADE =
  'linear-gradient(115deg, #233240 0%, #3d5166 35%, #5c8ab8 72%, #5c8ab8 100%)'
const FILET = 'rgba(255,255,255,.16)'
const TEXTE_DOUX = 'rgba(255,255,255,.75)'

// Variante de FOND (2026-08-21, alignement du bandeau Contrôle) : `fond`
// remplace le dégradé navy — le TERRACOTTA du signalement de points vit ici
// désormais, plus dans une copie locale. `onRetour` (bouton Retour au-dessus
// du titre) et `progression` (barre 4px sous le contenu) descendent aussi de
// l'ancien bandeau maison de l'écran Contrôle : UNE carte, toutes les pages.
export default function CarteTitrePage({ titre, sousTitre, dateTexte, chiffres, sousLeFilet, actions, testId,
  fond, onRetour, retourTestId = 'carte-titre-retour', progression, progressionTestId = 'carte-titre-progression' }) {
  const stats = (Array.isArray(chiffres) ? chiffres : []).filter(
    (c) => c && c.valeur !== null && c.valeur !== undefined && c.valeur !== ''
  )
  return (
    <header data-testid={testId}
      style={{ position: 'relative', overflow: 'hidden', background: fond || DEGRADE,
        borderRadius: 12, padding: '16px 18px', marginBottom: 14 }}>
      {onRetour && (
        <button type="button" onClick={onRetour} className="fbz-press fbz-tap"
          data-testid={retourTestId}
          style={{ position: 'relative', zIndex: 1, display: 'inline-flex',
            alignItems: 'center', gap: 4, minHeight: 32, background: 'none',
            border: 'none', padding: '0 6px 6px 0', color: 'rgba(255,255,255,.85)',
            fontSize: 12, fontWeight: 700, fontFamily: DS.fontBody, cursor: 'pointer' }}>
          <ChevronLeft size={15} strokeWidth={2.4} /> Retour
        </button>
      )}
      <div style={{ position: 'relative', zIndex: 1, display: 'flex',
        alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 240px', minWidth: 0 }}>
          <h1 style={{ fontFamily: DS.fontDisplay, fontSize: 22, fontWeight: 600,
            margin: 0, lineHeight: 1.15, color: '#fff' }}>
            {titre}
          </h1>
          {/* Le sous-titre = LA PHRASE DE RÔLE (correction Dimitri : elle
              avait disparu avec l'ancien bandeau — elle vit ICI désormais). */}
          {sousTitre && (
            <div style={{ fontSize: 11.5, marginTop: 4, color: TEXTE_DOUX }}>
              {sousTitre}
            </div>
          )}
        </div>
        {/* La date, à droite du titre. */}
        {dateTexte && (
          <span style={{ fontSize: 11.5, color: TEXTE_DOUX, flexShrink: 0 }}>
            {dateTexte}
          </span>
        )}
        {actions}
      </div>

      {/* LES CHIFFRES DU JOUR — séparés du titre par un filet, entre eux par
          des filets verticaux. Une carte qui répète le nom de l'onglet est
          décorative ; celle-là doit servir.
          ⚠️ UN CHIFFRE QUI COMPTE QUELQUE CHOSE MÈNE À CE QUELQUE CHOSE
          (Dimitri 2026-08-14) : `onClic` en fait un bouton (curseur + léger
          fond au survol, .fbz-chiffre-clic). Sans onClic, il reste un <div>
          inerte — jamais de faux bouton. */}
      {/* SOUS LE FILET, AU CHOIX DE LA PAGE (principe Dimitri 2026-08-15) :
          `sousLeFilet` = contenu libre — cartes d'action, ligne calme… Le
          bandeau ne montre que ce qui appelle une action ; quand il n'y en a
          pas, il le dit en une phrase et se tait. Il ne répète jamais ce que
          la page montre juste en dessous. `chiffres` reste l'autre forme
          (Suivi équipe — comparaison à l'écran avant de trancher). */}
      {sousLeFilet && (
        <div style={{ position: 'relative', zIndex: 1, marginTop: 12,
          paddingTop: 12, borderTop: `1px solid ${FILET}` }}>
          {sousLeFilet}
        </div>
      )}
      {stats.length > 0 && (
        <div style={{ position: 'relative', zIndex: 1, display: 'flex',
          alignItems: 'stretch', gap: 22, marginTop: 12, paddingTop: 12,
          borderTop: `1px solid ${FILET}`, flexWrap: 'wrap' }}>
          {stats.map((c, i) => {
            const interieur = (
              <>
                <div style={{ fontFamily: DS.fontDisplay, fontSize: 22, fontWeight: 600,
                  lineHeight: 1.1,
                  color: c.alerte && Number(c.valeur) > 0 ? '#f5a892' : '#fff',
                  fontVariantNumeric: 'tabular-nums' }}>
                  {c.valeur}
                </div>
                <div style={{ fontSize: 10.5, marginTop: 2, color: TEXTE_DOUX }}>
                  {c.libelle}
                </div>
              </>
            )
            return (
              <div key={c.cle || c.libelle || i}
                style={{ display: 'flex', alignItems: 'stretch', gap: 22 }}>
                {i > 0 && <span aria-hidden="true" style={{ width: 1, background: FILET }} />}
                {typeof c.onClic === 'function' ? (
                  <button type="button" data-testid={c.testId} onClick={c.onClic}
                    className="fbz-chiffre-clic fbz-cible-tactile"
                    aria-label={`${c.valeur} ${c.libelle} — voir`}>
                    {interieur}
                  </button>
                ) : (
                  <div data-testid={c.testId}>{interieur}</div>
                )}
              </div>
            )
          })}
        </div>
      )}
      {typeof progression === 'number' && (
        <div aria-hidden="true" style={{ position: 'relative', zIndex: 1, marginTop: 10,
          height: 4, borderRadius: 2, background: 'rgba(255,255,255,.25)' }}>
          <div data-testid={progressionTestId}
            style={{ width: `${Math.round(progression * 100)}%`, height: 4,
              borderRadius: 2, background: '#fff', transition: 'width .15s ease' }} />
        </div>
      )}
    </header>
  )
}

/** Le compteur d'alerte inline d'un sous-titre — #f5a892 sur le dégradé. */
export function CompteurAlerte({ children, testId }) {
  return (
    <span data-testid={testId} style={{ color: '#f5a892', fontWeight: 700 }}>
      {children}
    </span>
  )
}

/** Bouton de carte de titre : fond BLANC, texte navy. `actif` (mode d'argent
 *  ouvert = une alerte) : corail plein. */
export function boutonCarteTitre({ actif = false, fondActif = '#c1512d' } = {}) {
  return actif
    ? { display: 'inline-flex', alignItems: 'center', gap: 6, flexShrink: 0,
        background: fondActif, color: '#fff', border: '1px solid transparent',
        borderRadius: 9, padding: '9px 14px', fontSize: 12, fontWeight: 700,
        fontFamily: DS.fontBody, cursor: 'pointer' }
    : { display: 'inline-flex', alignItems: 'center', gap: 6, flexShrink: 0,
        background: '#fff', color: '#3d5166', border: '1px solid transparent',
        borderRadius: 9, padding: '9px 14px', fontSize: 12, fontWeight: 700,
        fontFamily: DS.fontBody, cursor: 'pointer' }
}

/** « jeudi 14 août » — la date du sous-titre, calculée au rendu. */
export function dateDuJourFR() {
  const s = new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/Paris',
  }).format(new Date())
  return s.charAt(0).toUpperCase() + s.slice(1)
}
